import { call, put, takeLatest } from "redux-saga/effects";

import {
  getAccountInfoSuccess,
  getAccountInfoFailure,
} from "./AccountInfo.actions";
import { AccountInfoService } from "./AccountInfo.store";

function* getAccountInfoSaga(args) {
  try {
    const accountInfoService = new AccountInfoService();
    const { rise, cash, trx, created } = yield call(
      accountInfoService.fetchAccountTransactions,
      args
    );
    yield put(getAccountInfoSuccess(rise, cash, trx, created));
  } catch (error) {
    yield put(getAccountInfoFailure(error));
  }
}

export function* accountInfoSagas() {
  const GET_ACCOUNTINFO = "GET_ACCOUNTINFO";
  yield takeLatest(GET_ACCOUNTINFO, getAccountInfoSaga);
}
